import { fetchAuthSession } from "@aws-amplify/auth";
import { resolveSessionForType } from "../auth/resolveSession";

const API_BASE = process.env.REACT_APP_FOLLOW_API_BASE ||
  "https://j8s1yjjjuf.execute-api.us-west-2.amazonaws.com/default";

const getAuthorCounts = async (route, signal) => {
  const { data: session } = await resolveSessionForType("author", {
    read: fetchAuthSession, restore: true,
  });
  const token = session?.tokens?.idToken?.toString?.();
  if (!token) throw new Error("Author session unavailable");
  const response = await fetch(`${API_BASE}/${route}`, {
    headers: { Authorization: `Bearer ${token}` }, signal,
  });
  if (!response.ok) throw new Error("Follower count unavailable");
  return response.json();
};

export const getAuthorFollowerCount = async ({ signal } = {}) => {
  const { count } = await getAuthorCounts("get-author-follower-count", signal);
  if (!Number.isSafeInteger(count) || count < 0) throw new Error("Invalid follower count");
  return count;
};

export const getAuthorGenreCounts = async ({ signal } = {}) => {
  const { genres } = await getAuthorCounts("get-author-genre-counts", signal);
  if (!Array.isArray(genres) || genres.some((item) =>
    typeof item?.genre !== "string" || !item.genre.trim() ||
    !Number.isSafeInteger(item.readers) || item.readers < 0
  )) throw new Error("Invalid genre counts");
  return genres.map(({ genre, readers }) => ({ genre, readers }));
};
